module.exports = __webpack_public_path__ + "static/InputField_textarea-3f0e066ece065a68329d58d342ec72e7.png";